import { config } from '../../../config';
import { FormikConsumer } from 'formik';
import axios from 'axios';
import debounce from 'awesome-debounce-promise';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextField from '../base/TextField';

const fetchZipData = (zip) => {
  return axios.get(config.API_DOMAIN + '/api/organization/zip/check.json', {
    params: { zip }
  });
};
const fetchZipDataDebounced = debounce(fetchZipData, 500);

class AutoZip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetchingZipData: false,
      cityData: [],
      countyData: [],
      stateData: []
    };

    this.zipChanged = this.zipChanged.bind(this);
  }

  zipChanged(zip, values, setFieldValue) {
    if (typeof zip !== 'undefined' && zip.trim().length > 4) {
      this.setState({ fetchingZipData: true });

      fetchZipDataDebounced(zip)
        .then((response) => {
          if (response.data.success) {
            const { cities, counties, states } = response.data;
            const pairs = { 'address_zip': zip };

            if (cities.length) {
              setFieldValue('address_city', cities[0])
              pairs['address_city'] = cities[0];
            }

            if (counties.length) {
              setFieldValue('address_county', counties[0])
              pairs['address_county'] = counties[0];
            }

            if (states.length) {
              setFieldValue('address_state', states[0])
              pairs['address_state'] = states[0];
            }

            this.setState({ fetchingZipData: false }, () => {
              this.props.onChangeCallback(pairs, values);
            });
          }
        })
        .catch((error) => {
          this.setState({ fetchingZipData: false });
        });
    }
  }

  render() {
    return (
      <FormikConsumer>
        {({ setFieldValue, values }) => (
          <div className="address-autozip-row">
            <TextField label="5-digit Zipcode"
              name={this.props.name + '_zip'}
              disabled={this.props.country !== 'US'}
              showThrobber={this.state.fetchingZipData}
              onChangeCallback={(name, value) => { this.zipChanged(value, values, setFieldValue) }} />
            <TextField label="City"
              name={this.props.name + '_city'}
              disabled={this.state.fetchingZipData || this.props.country !== 'US'}
              onChangeCallback={(name, value) => {
                this.props.onChangeCallback({ name: value }, values);
              }} />
            <TextField label="County"
              name={this.props.name + '_county'}
              disabled={this.state.fetchingZipData}
              onChangeCallback={(name, value) => {
                this.props.onChangeCallback({ name: value }, values);
              }} />
            <TextField label="State"
              name={this.props.name + '_state'}
              disabled={this.state.fetchingZipData}
              onChangeCallback={(name, value) => {
                this.props.onChangeCallback({ name: value }, values);
              }} />
          </div>
        )}
      </FormikConsumer>
    )
  }
}

AutoZip.defaultProps = {
  country: 'US',
  zip: '',
  city: '',
  state: '',
  county: '',
};

AutoZip.propTypes = {
  country: PropTypes.string,
  zip: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  county: PropTypes.string,
};

export default AutoZip;
